import { useEffect } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import { TopTip } from '@/components/UI/svg/Wave2';

const bannerMsE1: any = {
    us: ['“', '”'],
    fr: ['«', '»'],
};

export default function A({ stage }: any) {
    const { t } = useLang('smartdevices');
    const { useRouter } = useGlobal();
    const { locale } = useRouter();

    useEffect(() => {
        // 动画--组件A
        AniContainer.create({
            syncFromTo: [['.smart-devices-treaser-A .smart-msga', { opacity: 1, ease: 'linear' }, { opacity: 0.1 }]],
            triggerElement: '.smart-devices-treaser-A',
            triggerHook: 0,
            offset: -100,
            duration: 300,
        });
    }, []);

    return (
        <div className={`smart-devices-treaser-A ${css.smartDevicesTreaserA}`}>
            <div className="smart-img-sticky">
                <div className="smart-img">
                    <NextImage
                        webpSrc={require('@publicLocal/smart-devices-teaser/pc/smart-devices-banner.webp')}
                        src={require('@publicLocal/smart-devices-teaser/pc/smart-devices-banner.jpg')}
                    />
                </div>
            </div>
            {stage === 1 && (
                <div className="top-tip">
                    <TopTip />
                    <p className="text">{t('teaser.top_tip')}</p>
                </div>
            )}
            <div className="smart-msga">
                <div className="smart-logo">
                    <NextImage webpSrc={require('@publicLocal/ces_2023.webp')} src={require('@publicLocal/ces_2023.png')} />
                </div>
                {stage === 1 && <div className="smart-msga1">{t('teaser.bannerTitle')}</div>}
                <div className="smart-msga2">{t('teaser.bannerMs1')}</div>
                <div className="smart-msga3">{t('teaser.bannerMs2')}</div>
            </div>
            <div className="smart-msgb-box">
                <div className="smart-msgb smart-msgb1">
                    <div className="smart-msgb-in">
                        <div className="smart-msgb1">{t('teaser.bannerMsC1')}</div>
                        <div className="smart-msgb2">{t('teaser.bannerMsC2')}</div>
                    </div>
                </div>
                <div className="smart-msg-box-wrapper">
                    <div className="smart-msgb smart-msgb2">
                        <div className="smart-msgb-in">
                            <div className="smart-msgb1">{t('teaser.bannerMsB1')}</div>
                            <div className="smart-msgb2">{t('teaser.bannerMsB2')}</div>
                        </div>
                    </div>
                    <div className="smart-msgb smart-msgb3">
                        <div className="smart-msgb-in">
                            <div className="smart-msgb1">{t('teaser.bannerMsD1')}</div>
                            <div className="smart-msgb2">{t('teaser.bannerMsD2')}</div>
                        </div>
                    </div>
                </div>
                <div className="smart-msgc">
                    <div className="smart-msgc-in">
                        <div className="smart-msgc1">
                            <div className="smart-msgc-tip1">{bannerMsE1[locale] ? bannerMsE1[locale][0] : bannerMsE1.us[0]}</div>
                            <div>
                                <span className="smart-msgc-text">{t('teaser.bannerMsE1')}</span>
                                <span className="smart-msgc-tip2">{bannerMsE1[locale] ? bannerMsE1[locale][1] : bannerMsE1.us[1]}</span>
                            </div>
                        </div>
                        <div className="smart-msgc2">
                            {t.rich('teaser.bannerMsE2', {
                                name: (text: string) => <span className="smart-msgc2-name">{text}</span>,
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
